import { render, staticRenderFns } from "./AddLog.vue?vue&type=template&id=71bb9bd2&scoped=true"
import script from "./AddLog.vue?vue&type=script&lang=ts"
export * from "./AddLog.vue?vue&type=script&lang=ts"
import style0 from "./AddLog.vue?vue&type=style&index=0&id=71bb9bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb9bd2",
  null
  
)

export default component.exports